import React, { createRef,useEffect } from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function ProfilePageHeader({ numberOfMember ,profile, isLoadingProfile}) {
  let pageHeader = createRef();

  useEffect(() => {
    if (window.innerWidth > 991) {
      // const updateScroll = () => {
      //   let windowScrollTop = window.pageYOffset / 3;
      //   pageHeader.current.style.transform =
      //     "translate3d(0," + windowScrollTop + "px,0)";
      // };
      // window.addEventListener("scroll", updateScroll);
      // return function cleanup() {
      //   window.removeEventListener("scroll", updateScroll);
      // };
    }
  });

  useEffect(()=>{
     
  },[profile]);

  return (
    <>
      <div
        className="page-header clear-filter page-header-small"
        filter-color="blue"
      >
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/bg5.jpg") + ")",
          }}
          // ref={pageHeader}
        ></div>
        <Container>
          <div className="photo-container">
            <img alt="..."  src={require("assets/img/avatar-counsellor.jpeg")}></img>
          </div>
          { isLoadingProfile && <h4>กำลังโหลดข้อมูลผู้ใช้</h4>}
          <h4 className="title">{profile.person_first_name} {profile.person_last_name}</h4> 
          { profile.person_type == 4 && <p className="category">อาจารย์/ผู้ให้การปรึกษา</p> }
          { profile.person_type == 3 && <p className="category">ผู้ให้การปรึกษา</p> }
          { profile.person_type == 2 && <p className="category">ผู้ดูแลระบบ</p> }
          { profile.person_type == 1 && <p className="category">ผู้รับการปรึกษา</p>}
         {/*  <div className="content">
            <div className="social-description">
              <h2>{numberOfMember} คน</h2>
              <p>ผู้รับบริการทั้งหมด</p>
            </div>
          </div> */}
        </Container>
      </div>
    </>
  );
}

export default ProfilePageHeader;
